import {
    Button,
    Header,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
} from '@/platform/ui';
import { usePage } from '@inertiajs/react';

const ShowView = () => {
    const { note } = usePage().props;

    return (
        <Modal open={true} onClose={() => window.history.back()}>
            <ModalHeader>Notitie detail</ModalHeader>
            <ModalContent>
                <Header
                    as='h3'
                    subheader={`${note?.customer?.customer_number} | ${note?.customer?.name}`}
                >
                    {note?.subject}
                </Header>

                <p className='mt-4'>{note?.action}</p>
            </ModalContent>
            <ModalActions>
                <Button type='button' onClick={() => window.history.back()}>
                    Sluiten
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default ShowView;
